import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport';

import { TrackingClient } from './generated/tracks.client';

export class TrackApiWebClient extends TrackingClient {
  constructor(host: string) {
    const transport = new GrpcWebFetchTransport({
      baseUrl: host,
      format: 'binary',
      credentials: 'include',
    });

    super(transport);
  }
}

export * from './generated/tracks';
export * from './generated/tracks.client';
